import autobind from 'autobind-decorator'
import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Alert, Button, Empty, Icon, Row, Select, Spin, DatePicker, Tag, Col, Tooltip, Modal, Input, List } from 'antd'
import { connect } from 'redux-scaffolding-ts'
import { EmployeeSummary, ReportEmployeesStore } from 'src/stores/employees-store'
import { Query } from 'src/core/stores/dataStore'
import FileSaver from 'file-saver'
import 'react-splitter-layout/lib/index.css'
import HttpService, { formatMessage } from 'src/core/services/http.service'
import EmployeeReportChart, { GetColors } from '../../../components/employees-report-chart'
import EmployeeReportTable from '../../../components/employees-report-table'
import moment from 'moment-timezone'
import { Moment } from 'moment'
import { FormComponentProps } from 'antd/lib/form'
import Form, { GetFieldDecoratorOptions } from 'antd/lib/form/Form'
import FormItem from 'antd/lib/form/FormItem'
import { nameof } from '../../../core/utils/object'
import '../../../assets/custom.scss'
import { successNotification } from '../../../components/systemNotifications/notificationService'
import EmployeeEditor from '../../../components/employee-editor-all'
import { exists } from 'fs'
import DateRange from '../../../components/dateRange'
import { resolve } from '../../../inversify.config'


const { MonthPicker, RangePicker, WeekPicker } = DatePicker
const { Option } = Select



interface TotalsReportViewState {
  error?: string
  isBusy: boolean
  employees: EmployeeSummary[]
  selectedEmployees: string[]
  fromDateStamp: number
  toDateStamp: number,
  openVisible: boolean,
  saveVisible: boolean,
  period: any
}




// tslint:disable-next-line:no-empty-interface
export type TotalsReportViewProps = {
  isAdmin: boolean
  companyId: string

}


export interface TotalReportEmployeesStoredList {

  listName: string,
  employees: string[],
  id : string


}


interface StoredEmployeesListState {
  saveVisible: boolean
  openVisible: boolean
  storedList: TotalReportEmployeesStoredList[]
  saveListname: string
  error?: string

}




// tslint:disable-next-line:no-empty-interface
export type StoredEmployeesListProps = {
  mode: 'open' | 'save'
  onClose: () => void
  allEmployees: EmployeeSummary[],
  selectedEmployees: string[]
  onSelectEmployees: (selected: string[]) => void

}


class StoredEmployeesList extends React.Component<StoredEmployeesListProps & WithTranslation, StoredEmployeesListState> {

  @resolve(HttpService)
  private httpService!: HttpService
  constructor(props: StoredEmployeesListProps & WithTranslation) {
    super(props)
    this.state = {
      saveVisible: props.mode == 'save',
      openVisible: props.mode == 'open',
      storedList: [],
      saveListname: "",
    }
  }

  load = async () => {
    try {
      const response = await this.httpService.get(`${process.env.PUBLIC_URL}/api/v1/admin/totalReportList`)

      if (response) {
        const data = response.data
        this.setState({ storedList: data as any })
      } else {
        this.setState({ error: this.props.t("Failed to load stored employee lists.") })
      }
    } catch (err) {
      this.setState({ error: this.props.t("Error loading stored employee lists.") })
    }
  }

  async componentDidMount() {
    await this.load();
  }

  componentWillMount() {
  }

  handleOkSave = () => {
    this.save(this.state.saveListname)
  };

  handleOkOpen = () => {
    this.save(this.state.saveListname)
  };

  save =async (listname: string) => {
    if (!listname || listname.length == 0) {
      this.setState({ error: this.props.t("The list to saved must have a name...") })
      return;
    }
    else {
      this.setState({ error: "" })
    }
    let toSave = { listName: listname, employees: this.props.selectedEmployees }

    const response = await this.httpService.post(`${process.env.PUBLIC_URL}/api/v1/admin/totalReportList`, toSave);

    //this.load();
    this.props.onClose()
  }

  handleCancel = () => {
    this.props.onClose()
  };
  delete = async (id: string) => {
    await this.httpService.delete(`${process.env.PUBLIC_URL}/api/v1/admin/totalReportList/${id}`)
    await this.load();

  }

  open = (name: string) => {

    var current = this.state.storedList
    let exist = current.firstOrDefault(x => x.listName == name)
    if (exist)
      this.props.onSelectEmployees(exist.employees)
  }

  public render() {
    const { t, mode } = this.props


    if (mode == 'save')
      return <Modal
        visible={true}
        title={t("Save List")}
        onOk={this.handleOkSave}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" onClick={this.handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleOkSave}>
            {t("Save")}
          </Button>,
        ]}
      >
        {this.state.error && <Alert type="error" message={this.state.error}></Alert>}
        <FormItem label={t("New List name")}>
          <Input value={this.state.saveListname} onChange={(name) => { this.setState({ saveListname: name.target.value }) }}></Input>
        </FormItem>
        <FormItem label={t("List Stored")}>
          <List
            itemLayout="vertical"
            size="large"

            dataSource={this.state.storedList}

            renderItem={item => (
              <List.Item
                key={item.listName}
                actions={[
                  <span onClick={() => { this.save(item.listName); this.props.onClose() }}>
                    <Icon type={"select"} style={{ marginRight: 8 }} />
                    {t("Override")}
                  </span>,
                  <span onClick={() => { this.delete(item.id) }}>
                    <Icon type={"delete"} style={{ marginRight: 8 }} />
                    {t("Delete")}
                  </span>

                ]}

              >
                {item.listName}
              </List.Item>
            )}
          />,
        </FormItem>


      </Modal>


    else
      return <Modal
        visible={true}
        title={t("Open List")}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" onClick={this.handleCancel}>
            {t("Cancel")}
          </Button>,
        ]}
      >
        {this.state.error && <Alert type="error" message={this.state.error}></Alert>}
        <FormItem label={t("List Stored")}>
          <List
            itemLayout="vertical"
            size="large"

            dataSource={this.state.storedList}

            renderItem={item => (
              <List.Item
                key={item.listName}
                actions={[
                  <span onClick={() => { this.open(item.listName); this.props.onClose() }}>
                    <Icon type={"select"} style={{ marginRight: 8 }} />
                    {t("Open")}
                  </span>,
                  <span onClick={() => { this.delete(item.id) }}>
                    <Icon type={"delete"} style={{ marginRight: 8 }} />
                    {t("Delete")}
                  </span>

                ]}

              >
                {item.listName}
              </List.Item>
            )}
          />
        </FormItem>


      </Modal>
  }
}


class TotalsReportDashboard extends React.Component<TotalsReportViewProps & WithTranslation & FormComponentProps, TotalsReportViewState> {

  @resolve(HttpService)
  private httpService!: HttpService
  constructor(props: TotalsReportViewProps & WithTranslation & FormComponentProps) {
    super(props)
    this.state = {

      isBusy: false,
      employees: [],
      selectedEmployees: [],
      fromDateStamp: 0,
      toDateStamp: 0,
      openVisible: false,
      saveVisible: false,
      period: {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month')
      }
    }
  }

  componentWillMount() {
  }



  private onBillingPeriodChange(data: any) {
    console.log(data)
  }

  private async createReport() {
    try {
      if (!this.state.selectedEmployees || this.state.selectedEmployees.length == 0) {
        this.setState({ error: this.props.t("You need to select employees") })
        return;
      } this.setState({error : ""})
      this.setState({ isBusy: true })
      let fromDateStamp: number = this.state.period.startDate!.startOf("day").unix()
      let toDateStamp: number = this.state.period.endDate!.endOf("day").unix()


      var data = {
        employeesIds: this.state.selectedEmployees,
        fromDateStamp: fromDateStamp,
        toDateStamp: toDateStamp,
      }
      let url = `${process.env.PUBLIC_URL}/api/v1/timesheet/${this.props.companyId}/totalReport`
      var result = await this.httpService.post<any, any>(url, data, { responseType: 'arraybuffer' })
      this.setState({ isBusy: false })
      const blob = new Blob([result.data as any], { type: result.headers['content-type'] });
      (FileSaver as any).saveAs(blob, `billableReport.xlsx`)

    } catch (error) {
      this.setState({ isBusy: false, error: formatMessage(error) })
    }
  }


  public render() {
    const { t, isAdmin, companyId } = this.props
    const { getFieldDecorator, getFieldValue, validateFields } = this.props.form


    return <div>
      <Spin size='large' spinning={this.state.isBusy}>
        <Row align='top' justify='space-between'>
          {this.state.error && <Alert type='error' message={this.state.error} />}
          <Row gutter={24}>
            <Col span={24}>
              <Tag style={{ marginBottom: 20 }} color="rgb(0,0,164)" >{t("Create your own totals report for the selected billing period")}</Tag>
            </Col>
            <Col style={{ marginBottom: 10 }} span={13}>
              <FormItem label={t('Period')}>

                <DateRange value={this.state.period} onChange={(value) => this.setState({ period: value })} />

              </FormItem>
            </Col>
            <Col style={{ marginBottom: 10 }} span={12}>
              <EmployeeEditor placeholder={t("Select Employees")} nullable value={this.state.selectedEmployees as any} onChange={(value) => this.setState({ selectedEmployees: value as any })} multiple onLoadAll={(employees) => { this.setState({ employees: employees }) }} companyId={companyId}></EmployeeEditor>
            </Col>
            <Col style={{ marginBottom: 10 }} span={12}>
              <Tooltip title={"Load saved employee list."}><Button onClick={() => this.setState({ openVisible: true })} type="primary" style={{ marginRight: 10 }} icon={"upload"}></Button></Tooltip>
              <Tooltip title={"Save the current employee list."}> <Button onClick={() => this.setState({ saveVisible: true })} type="danger" style={{ marginRight: 10 }} icon={"download"}></Button>  </Tooltip>
            </Col>
            <Col span={24}>
              <Button onClick={() => this.createReport()} type="primary" style={{ marginRight: 10 }} icon={"area-chart"}>{t("Create Report")}</Button>
            </Col>
          </Row>
        </Row>
        {(this.state.saveVisible || this.state.openVisible) && <StoredEmployeesList onSelectEmployees={(em) => this.setState({ selectedEmployees: em })} allEmployees={this.state.employees} onClose={() => this.setState({ openVisible: false, saveVisible: false })} selectedEmployees={this.state.selectedEmployees} mode={this.state.openVisible ? "open" : "save"} {...this.props} />}
      </Spin>
    </div>
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(TotalsReportDashboard as any) as any) as any as React.ComponentClass<TotalsReportViewProps>